<template>
  <div class="o-catalog-item-placeholder placeholder-loader">
    <div class="o-catalog-item-placeholder__pic placeholder-loader__item"></div>
    <div class="o-catalog-item-placeholder__title placeholder-loader__item"></div>
    <div v-if="type === 'level'" class="o-catalog-item-placeholder__price placeholder-loader__item"></div>
  </div>
</template>

<script>
export default {
  name: 'CatalogItemPlaceholder',
  props: {
    type: {
      type: String,
      default: 'level'
    }
  }
};
</script>

<style lang="scss">
@import '../assets/styles/components/placeholder-loader';
</style>
